export default "__VITE_ASSET__CLtWt5VO__"